"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GuiMiddleware", {
    enumerable: true,
    get: function() {
        return GuiMiddleware;
    }
});
const _common = require("@nestjs/common");
const _nclibgui = /*#__PURE__*/ _interop_require_default(require("nc-lib-gui"));
const _config = require("@nestjs/config");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GuiMiddleware = class GuiMiddleware {
    use(req, res, next) {
        const dashboardPath = this.configService.get('dashboardPath', {
            infer: true
        });
        _nclibgui.default.expressMiddleware(dashboardPath)(req, res, next);
    }
    constructor(configService){
        this.configService = configService;
    }
};
GuiMiddleware = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], GuiMiddleware);
